import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { PDFProvider } from "@context/PDFContext";
import { ErrorProvider } from "@context/ErrorContext";
import { FormProvider } from "@context/FormContext";
import AppRoutes from "./routes/routes";
import ImpersonationBanner from "@components/layout/ImpersonationBanner";
import FeedbackButton from "@components/layout/FeedbackButton";
import ErrorBoundary from "@components/common/ErrorBoundary";
function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsAuthenticated(!!token);
    setLoading(false);
  }, []);

  if (loading) return null;

  return (
    <ErrorBoundary>
      <ErrorProvider>
        <PDFProvider>
          <FormProvider>
            <Router>
              <ImpersonationBanner />
              <AppRoutes
                isAuthenticated={isAuthenticated}
                setIsAuthenticated={setIsAuthenticated}
              />
              {isAuthenticated && <FeedbackButton />}
            </Router>
          </FormProvider>
        </PDFProvider>
      </ErrorProvider>
    </ErrorBoundary>
  );
}

export default App;
